import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { Box, Collapse } from "@material-ui/core";
import { MUIBlock } from "../../MUI";
import * as styles from "./styles.scss";
import { CoursesGroup } from "./CoursesGroup";
import { GroupCover } from "./GroupCover";
import { themeVariables } from "../_Theme";
import { FSCourseGroup as CoursesGroupEntity } from "../../Filestorage/CoursesList/store";

interface IProps {
  group: CoursesGroupEntity;
  showIconLabel?: boolean;
  module?: string;
  hRef?: string;
  target?: string;
  onCourseClick?: any;
  isExtended?:boolean;
}

export const GroupCard = observer((props: IProps) => {
  const { fsStore, groupSettingsStore } = React.useContext(MobXProviderContext);
  const [extended, toggleGroupExtend] = React.useState(props.isExtended);

  const { group } = props;
  return (
    <MUIBlock
      key={`group${group.id}`}
      mb={!!fsStore && fsStore.isWidget ? 0 : 2}
      m={!!fsStore && fsStore.isWidget ? "-1px" : undefined}
      pInner={0}
      data={{ style: { overflow: "hidden" } }}
    >
      <GroupCover
        {...props}
        extended={extended}
        toggleGroupExtend={
          props.hRef || props.onCourseClick
            ? () => toggleGroupExtend(!extended)
            : null
        }
      />
      {props.hRef || props.onCourseClick ? (
        <Collapse in={extended} mountOnEnter>
          <Box
            flex={1}
            mb={!!fsStore && fsStore.isWidget ? undefined : 1}
            className={styles.group}
            borderTop={themeVariables.border}
            borderBottom={themeVariables.border}
          >
            <CoursesGroup
              // groupId={group.id}
              group={group}
              getMoreCourses={() => group.getMoreCourses()}
              href={props.hRef}
              onCourseClick={props.onCourseClick}
              target={props.target}
              loading={props.group.loading}
              loadingNext={props.group.loadingNext}
              module={"panel"}
              groupCardWide={
                groupSettingsStore ? groupSettingsStore.groupCardWide : false
              }
              isWidget={fsStore ? fsStore.isWidget : false}
              extended={extended}
            />
          </Box>
        </Collapse>
      ) : null}
    </MUIBlock>
  );
});
